export enum PinwheelEvents {
  // core events
  Open = 'open',
  Exit = 'exit',
  Success = 'success',
  PinWheelError = 'error',
  InputRequired = 'input_required',

  // employer/platform events
  SelectEmployer = 'select_employer',
  SelectPlatform = 'select_platform',

  // login events
  Login = 'login',
  LoginAttempt = 'login_attempt',
  MerchantLoginSuccess = 'merchant_login_success',

  // direct deposit switch events
  InputAmount = 'input_amount',
  InputAllocation = 'input_allocation',

  // direct deposit form events
  DdFormBegin = 'dd_form_begin',
  DdFormCreate = 'dd_form_create',
  DdFormDownload = 'dd_form_download',

  // bill switch events
  BillSwitchSuccess = 'bill_switch_success',
  BillCancelSuccess = 'bill_cancel_success',
  ExternalAccountConnected = 'external_account_connected',
  BillRemoved = 'bill_removed',

  // navigation events
  ScreenTransition = 'screen_transition',

  // note: most of this looks like it should not be in PinwheelEvents:
  Other = 'other_event',
  PLATFORM_ELIGIBILITY_LOOKUP_LOADING = 'platform_eligibility_lookup_loading',
  SearchDefault = 'search_default',
  SearchResults = 'search_results',
  SearchPlatform = 'search_platform_only',
  ProviderConfirmation = 'provider_confirmation',
  DDAmountSelection = 'dd_amount_selection',
  DDConfirmation = 'dd_confirmation',
  JobSuccess = 'job_success',
  JobError = 'job_error',
  ExitConfirmation = 'exit_confirmation',
  LookupResult = 'platform_eligibility_lookup_results',
  LookupHelp = 'platform_eligibility_lookup_help',
}
